import { Redirect, Route, Switch } from 'react-router-dom';
import { EVENTS_ROOT } from 'src/redesign/shared/routes';
import { EventRouter } from 'src/redesign/router';
import { SiteWrapper } from 'src/app';
import React, { Suspense } from 'react';
import { Loader } from 'src/redesign/components/Loader';
import { SiteRouter } from 'src/features/SiteRouter';
import { AttendeeEventsPage } from 'src/redesign/pages/AttendeeEventsPage';
import { AttendeeTicketDetailsPage } from 'src/redesign/pages/AttendeeTicketDetailsPage';

const AttendeeTicketPage = React.lazy(() =>
  import('src/modules/tickets').then((module) => ({ default: module.AttendeeTickets })),
);

const WixWidgetsPage = React.lazy(() =>
  import('src/modules/sites/wix-widgets').then((module) => ({ default: module.WixWidgets })),
);

const AdvancedEmailEditorPage = React.lazy(() =>
  import('src/modules/campaigns/advanced-email-editor').then((module) => ({
    default: module.AdvancedEmailEditor,
  })),
);

export const AuthRouter = () => {
  return (
    <Switch>
      <Route exact path="/" component={() => <Redirect to={EVENTS_ROOT} />} />
      <Route
        exact
        path="/my-tickets"
        component={() => (
          <Suspense fallback={<Loader size="small" />}>
            <AttendeeTicketPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/wix-widgets"
        component={() => (
          <Suspense fallback={<Loader />}>
            <WixWidgetsPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path={`/campaigns/email-editor/:id`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props} noAuth>
              <AdvancedEmailEditorPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route path="/sites">
        <SiteRouter />
      </Route>
      <Route path={EVENTS_ROOT}>
        <EventRouter />
      </Route>
      <Route
        exact
        path="/attendee-dashboard/ticket/:cartId/order"
        render={(props) => {
          return (
            <Suspense fallback={<Loader />}>
              <SiteWrapper {...props} noAuth>
                <AttendeeTicketDetailsPage />
              </SiteWrapper>
            </Suspense>
          );
        }}
      />
      <Route
        path="/attendee-dashboard/ticket/:cartId"
        render={(props) => {
          return (
            <Suspense fallback={<Loader />}>
              <SiteWrapper {...props} noAuth>
                <AttendeeEventsPage />
              </SiteWrapper>
            </Suspense>
          );
        }}
      />
      <Route path="/attendee-dashboard">
        <AttendeeEventsPage />
      </Route>
    </Switch>
  );
};
